'use strict';

function defaultNewDate() {
  return new Date;
}

module.exports = defaultNewDate;